/* Selet v98 (02/10): stub do Swiper sob demanda — antes inline no <head> de layout/theme.liquid (5,8 KB). Carregado com defer ANTES de motion/global.aio.min.js (scripts defer executam na ordem do documento), então window.Swiper continua definido antes dos inicializadores do tema. URL do bundle vem de window.SeletCfg.swiperSrc (inline, Liquid). */
(function () {
        var src = (window.SeletCfg && SeletCfg.swiperSrc) || '';
        var list = [], queue = [], promise = null, Real = null;
        /* Selet v102 (02/10): página sem carrossel Swiper visível (home sem Swiper) => modo sob demanda: o bundle (JS + CSS) só carrega no 1º clique/tecla ou quando algo cria um Swiper depois do carregamento (quickview, upsell do carrinho). */
        var cssSrc = (window.SeletCfg && SeletCfg.swiperCss) || '';
        var onDemand = false, domReady = false;
        var METHODS = ['on', 'once', 'off', 'emit', 'slideTo', 'slideToLoop', 'slideNext', 'slidePrev', 'slideReset', 'update', 'updateSize', 'updateSlides', 'updateProgress', 'updateSlidesClasses', 'updateAutoHeight', 'appendSlide', 'prependSlide', 'addSlide', 'removeSlide', 'removeAllSlides', 'setProgress', 'setTranslate', 'translateTo', 'changeDirection', 'changeLanguageDirection', 'enable', 'disable', 'init', 'destroy'];
        function Stub(el, params) {
          if (!(this instanceof Stub)) return new Stub(el, params);
          this.el = el; this.params = params || {}; this._q = []; this._real = null; this._dead = false;
          this.slides = []; this.activeIndex = 0; this.realIndex = 0; this.previousIndex = 0; this.isBeginning = true; this.isEnd = false; this.initialized = false; this.destroyed = false;
          this.autoplay = { running: false, paused: false, start: function () {}, stop: function () {}, pause: function () {}, resume: function () {} };
          if (el && typeof el === 'object' && el.nodeType === 1 && !el.swiper) { try { el.swiper = this; } catch (e) {} }
          list.push(this);
          if (onDemand && domReady) load();
        }
        METHODS.forEach(function (m) {
          Stub.prototype[m] = function () {
            var args = Array.prototype.slice.call(arguments);
            if (this._real) { return this._real[m].apply(this._real, args); }
            if (m === 'destroy') { this._dead = true; return; }
            this._q.push([m, args]);
            return this;
          };
        });
        Stub.__seletStub = true;
        window.Swiper = Stub;

        function materialize() {
          var pending = list; list = [];
          pending.forEach(function (stub) {
            if (stub._dead || stub._real) return;
            try {
              var params = Object.assign({}, stub.params);
              if (params.thumbs && params.thumbs.swiper && params.thumbs.swiper instanceof Stub) {
                params.thumbs = Object.assign({}, params.thumbs, { swiper: params.thumbs.swiper._real || null });
              }
              var real = new Real(stub.el, params);
              stub._real = real;
              ['slides', 'activeIndex', 'realIndex', 'previousIndex', 'isBeginning', 'isEnd', 'initialized', 'destroyed', 'autoplay', 'params'].forEach(function (p) {
                try { Object.defineProperty(stub, p, { get: function () { return real[p]; }, set: function (v) { real[p] = v; }, configurable: true }); } catch (e) {}
              });
              var q = stub._q; stub._q = [];
              q.forEach(function (c) { try { real[c[0]].apply(real, c[1]); } catch (e) { console.error('[selet swiper] replay', c[0], e); } });
            } catch (e) { console.error('[selet swiper] init', e); }
          });
        }
        function load() {
          if (promise) return promise;
          if (cssSrc && !document.querySelector('link[data-selet-swiper-css]')) {
            var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = cssSrc; l.setAttribute('data-selet-swiper-css', ''); document.head.appendChild(l);
          }
          promise = new Promise(function (resolve, reject) {
            var s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = function () {
              if (!window.Swiper || window.Swiper.__seletStub) { reject(new Error('Swiper não carregou')); return; }
              Real = window.Swiper;
              resolve(Real);
            };
            s.onerror = function () { promise = null; reject(new Error('swiper-bundle.min.js')); };
            document.head.appendChild(s);
          }).then(function (S) {
            materialize();
            var cbs = queue; queue = [];
            cbs.forEach(function (fn) { try { fn(S); } catch (e) { console.error('[selet swiper]', e); } });
            document.dispatchEvent(new CustomEvent('selet:swiper-ready'));
            return S;
          });
          promise.catch(function (e) { console.error('[selet swiper]', e); });
          return promise;
        }
        window.seletLoadSwiper = load;
        window.seletOnSwiper = function (fn) { if (Real) { fn(Real); } else { queue.push(fn); load(); } };
        /* Instâncias criadas depois que o Swiper real já carregou (ex.: quickview aberto mais tarde) nascem reais: */
        document.addEventListener('selet:swiper-ready', function () {
          window.Swiper = Real; /* a partir daqui new Swiper() já é o real */
          if (list.length) materialize();
        });

        var events = ['touchstart', 'scroll', 'keydown', 'mousemove', 'wheel', 'click'];
        function trigger() {
          events.forEach(function (ev) { window.removeEventListener(ev, trigger, { passive: true }); });
          load();
        }
        events.forEach(function (ev) { window.addEventListener(ev, trigger, { passive: true }); });
        window.addEventListener('load', function () { setTimeout(function () { if (!onDemand) trigger(); }, 3000); });
        document.addEventListener('DOMContentLoaded', function () {
          domReady = true;
          if (window.Shopify && Shopify.designMode) { trigger(); return; }
          if (cssSrc && !document.querySelector('.swiper:not(.swiper-cart-upsell)')) {
            onDemand = true;
            ['touchstart', 'scroll', 'mousemove', 'wheel'].forEach(function (ev) { window.removeEventListener(ev, trigger, { passive: true }); });
            return;
          }
          if (!('IntersectionObserver' in window)) return;
          var first = document.querySelector('.swiper');
          if (!first) return;
          /* Carrossel já visível na primeira tela (hero/galeria): fica estático no 1º slide até a interação ou 3 s após o load.
             Carrossel abaixo da dobra: carrega quando se aproxima da tela. */
          if (first.getBoundingClientRect().top < window.innerHeight + 200) return;
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); trigger(); }
          }, { rootMargin: '200px' });
          io.observe(first);
        });
      })();
